import _ from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import { dicreaseTooltipMargin } from 'components/Tooltips/helpers';
import { Flex, Margin } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { PROJECTS } from '../services/projects.services';

const LegendItem = ({
  icon,
  sum,
  subValue = '',
  tooltipTitle = '',
  name,
  isTooltip = false,
  isHorizontalView = true,
  showTitleEllipsisAfter = '8rem'
}) => {
  const ellipsisStyle =
    !isTooltip && showTitleEllipsisAfter
      ? {
          width: showTitleEllipsisAfter,
          ellipsisAfter: showTitleEllipsisAfter
        }
      : {};

  return (
    <Tooltip
      data-testid='legend-item-tooltip'
      disableHoverListener={isTooltip}
      classes={dicreaseTooltipMargin()}
      position='bottom'
      title={
        <Text size='small' color='shuttleGray'>
          {`${sum} ${subValue} ${_.capitalize(tooltipTitle || name)}`}
        </Text>
      }
    >
      {isHorizontalView ? (
        <div>
          <Margin b='x-x-small' data-testid='legend-icon'>
            {icon}
          </Margin>
          <Text size='large' data-testid='legend-sum'>
            {sum}
          </Text>
          <Text
            className='multiLineEllipsis'
            color={PROJECTS.SECONDARY_COLOR}
            multiLineEllipsisAfter={2}
            width='6rem'
            data-testid='legend-name'
          >
            {_.capitalize(name)}
          </Text>
        </div>
      ) : (
        <Flex items='center' mb='x-small'>
          <Margin data-testid='legend-icon' r='smaller'>
            {icon}
          </Margin>
          <Text
            size='medium'
            mr='0.5rem'
            ellipsisAfter='3.4rem'
            align='left'
            data-testid='legend-sum'
          >
            {sum}
          </Text>
          {subValue && (
            <Text size='small' mr='0.3rem'>
              {subValue}
            </Text>
          )}
          <Text
            color={PROJECTS.SECONDARY_COLOR}
            data-testid='legend-name'
            {...ellipsisStyle}
          >
            {_.capitalize(name)}
          </Text>
        </Flex>
      )}
    </Tooltip>
  );
};

export default LegendItem;
